var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReplacementBus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#replacement-bus_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#DC0451",
  d: "M3 .5h18A2.5 2.5 0 0 1 23.5 3v18a2.5 2.5 0 0 1-2.5 2.5H3A2.5 2.5 0 0 1 .5 21V3A2.5 2.5 0 0 1 3 .5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DC0451",
  fillRule: "evenodd",
  d: "M18.075 2.4H5.925c-.67 0-1.214.544-1.214 1.215v14.58c0 .67.543 1.214 1.215 1.214v2.192h1.86v-2.192h8.429v2.192h1.86v-2.192c.67 0 1.215-.543 1.215-1.215V3.615c0-.671-.544-1.215-1.215-1.215M9.3 3.486h5.4V4.4H9.3zM6.856 17.232a.93.93 0 1 1 0-1.86.93.93 0 0 1 0 1.86m10.288 0a.93.93 0 1 1 0-1.86.93.93 0 0 1 0 1.86m.93-4.854c0 .22-.146.412-.359.469-.847.228-3.093.755-5.715.755s-4.868-.527-5.715-.755a.485.485 0 0 1-.36-.47V5.795c0-.269.218-.486.486-.486h11.177c.268 0 .486.217.486.486z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "replacement-bus_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export { SvgReplacementBus as ReactComponent };